import { Fragment, useEffect } from "react";
import Head from "next/head";

/* Component Import */
import ProductCarousel from "@/components/home/product-carousel/product_carousel";
import TestimonialCarousel from "@/components/home/testimonial-carousel/testimonial_carousel";
import ArticleCarousel from "@/components/home/article/article-carousel";
import PartnerDeals from "@/components/home/partner-deals/partner_deals";
import InsuranceEase from "@/components/home/insurance-ease/insurance_ease";
import PartnerInsurerCarousel from "@/components/home/partner-insurer-carousel/partner_insurer_carousel";
import BuyStep from "@/components/home/buy-steps/buy_steps";
import CurationCarousel from "@/components/home/curation-carousel/curation_carousel";
import EventCarousel from "@/components/home/event-carousel/event_carousel";

/* CSS Import */
import style from "./style.module.css";

import * as Sentry from "@sentry/nextjs";

export default function Home() {
  Sentry.setTag("page", "home");
  return (
    <Fragment>
      <Head>
        <title>
          ค้นหา ประกันบ้าน ประกันอัคคีภัย ครอบคลุมไฟไหม้ น้ำท่วม โจรปล้น -
          บริษัท TQM
        </title>
      </Head>
      <section className={style.main_cta_section}>
        <div className={style.main_cta_background} />
        <div className={style.main_cta_container}>
          <InsuranceEase />
        </div>
      </section>
      <section className={style.partner_insurer_section}>
        <div className={style.partner_insurer_container}>
          <PartnerInsurerCarousel />
        </div>
      </section>
      {false && (
        <section className={style.curation_carousel_section}>
          <div className={style.curation_carousel_container}>
            <div id="promotion" className={style.anchor}/>
            <h2 className={style.title}>โปรโมชั่นสุดคุ้ม</h2>
            <CurationCarousel />
          </div>
        </section>
      )}
      <section className={style.product_carousel_section}>
        <div className={style.product_carousel_container}>
          <div className={style.product_carousel}>
            <ProductCarousel />
          </div>
        </div>
      </section>
      <section className={style.article_section}>
        <div className={style.article_container}>
          <div className={style.title}>
            <h2>เรื่องบ้านน่ารู้</h2>
          </div>
          <div className={style.article}>
            <ArticleCarousel />
          </div>
        </div>
      </section>
      <section className={style.buy_step_section}>
        <div className={style.step_container}>
          <BuyStep />
        </div>
      </section>
      <section className={style.testimonial_section}>
        <div className={style.testimonial_container}>
          <div className={style.testimonial}>
            <div className={style.title_wrapper}>
              <div className={style.title}>
                <h2>เสียงจากลูกค้า TQM HOME</h2>
              </div>
            </div>
            <div className={style.customers_testimonial}>
              <div className={style.carousel}>
                <TestimonialCarousel />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={style.partner_section}>
        <div className={style.partner_container}>
          <div className={style.title}>
            <h2>สิทธิพิเศษสำหรับคุณ</h2>
          </div>
          <PartnerDeals />
        </div>
      </section>
      <section className={style.event_section}>
        <div className={style.event_container}>
          <div className={style.title}>
            <h2>ข่าว กิจกรรม ประชาสัมพันธ์</h2>
          </div>
          <EventCarousel />
        </div>
      </section>
    </Fragment>
  );
}
